var slice = Array.prototype.slice;
export { slice };
//# sourceMappingURL=array.js.map
